'use client'

import Footer1 from '@/components/footers/Footer1'
import React, { useEffect } from 'react'
import { signOut, useSession } from 'next-auth/react'

export default function Logout() {
  const { data: session } = useSession()

  useEffect(() => {
    const controller = new AbortController()

    const doLogout = async () => {
      try {
        // 呼叫 Next 內部 API：會再轉給 C# 的 /member/logout
        await fetch('/api/front/v1/member/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(session?.AccessToken
              ? {
                  Authorization: `${session?.TokenType || 'Bearer'} ${session.AccessToken}`,
                }
              : {}),
          },
          body: JSON.stringify({ RefreshToken: session?.RefreshToken }),
          cache: 'no-store',
          signal: controller.signal,
        }).catch(() => {})
      } finally {
        // 不論成功失敗都登出 next-auth
        signOut({
          callbackUrl: process.env.NEXT_PUBLIC_BASE_URL,
          redirect: true,
        })
      }
    }

    doLogout()
    return () => controller.abort()
  }, [session])

  return (
    <>
      <main className="page-wrapper">
        <div className="mb-4 pb-4"></div>
        <div>登出會員</div>
      </main>

      <div className="mb-5 pb-xl-5"></div>
    </>
  )
}
